import React, { useState } from 'react';
import { Autocomplete,  Badge,  Box,  Button,  Checkbox,  Dialog,  DialogContent,  DialogTitle,  FormControl,  FormControlLabel,  Grid,  IconButton,  Input,  InputAdornment,  InputBase,  InputLabel,  MenuItem,  OutlinedInput,  Paper,  Select,  TextField,  } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useFetchData } from '../../../hooks/useFetchData/useFetchData';
import { useShowMessages } from '../../../hooks/useMessages/useMessages';
import FilterListIcon from '@mui/icons-material/FilterList';
import CustomMenuItem from '../../shared/CustomMenuItem';

let urlUsers = process.env.REACT_APP_API+ "/user/all";
let urlGroups = process.env.REACT_APP_API+ "/user/groups";

export const RequestsHeader = (props) => {
    const [changed, setChanged] = useState(false);
    const { data : listUsers } = useFetchData(urlUsers);
    const { data : listGroups } = useFetchData(urlGroups);
    const [values, setValues] = useState(props?.values);
    const { ShowMessage } = useShowMessages();
    const [openFilter, setOpenFilter] = useState(false);

  
    const handleCloseFilter = () => {
      setOpenFilter(false);
    }

    const handleOpenFilter = () => {
      setOpenFilter(true);
    }
  
  
    const handleChanged = () => {
      setChanged(!changed);
    }

    const handleChangeType = (values) => {
      setValues((prevValues) => (
        {
            ...prevValues, "type": (!values) ? '' : values.target.value,
      })); 

      sessionStorage.setItem('typeFilter', (!values) ? 'user' : values.target.value);
      handleChanged();
    }

    const handleChangeUser = (values) => {
        setValues((prevValues) => (
          {
              ...prevValues, id: (!values) ? null : values.id,
        }));  
        setValues((prevValues) => (
          {
              ...prevValues, "name": (!values) ? '' : values.name,
        })); 
        sessionStorage.setItem('userFilterId', (!values) ? null : values.id)     
        sessionStorage.setItem('userFilterName', (!values) ? null : values.name)  
    }

    const handleChangeGroup = (values) => {

      setValues((prevValues) => (
        {
            ...prevValues, 'idGroup': (!values) ? null : values.id,
      }));  
      setValues((prevValues) => (
        {
            ...prevValues, "nameGroup": (!values) ? '' : values.description,
      })); 

      sessionStorage.setItem('groupFilterId', (!values) ? null : values.id)     
      sessionStorage.setItem('groupFilterName', (!values) ? null : values.description)  
    }

    const handleSetFilter = (value) => {
      setValues((prevValues) => ({
        ...prevValues,
        'filter': value.target.value,
      }));
      sessionStorage.setItem('requestsFilter', (!values) ? null : value.target.value)
    }

    const handleChangeOrder = (value) => {
      setValues((prevValues) => ({
        ...prevValues,
        'order': value.target.value,
      }));
      sessionStorage.setItem('requestsOrderBy', (!values) ? 's.created_at' : value.target.value)
    }

    const handleChangeChecks = (value) => {
      setValues((prevValues) => ({
        ...prevValues,
        'ShowHiddenRequests': (value.target?.checked) ? 'Y' : 'N',
      }));
      sessionStorage.setItem('show_hidden_requests', (value.target?.checked) ? 'Y' : 'N')
    }

    const handleChangeOrderDirection = (value) => {
      const direction = value.target?.checked ? 'DESC' : 'ASC';
      const newValues = { ...values, orderDirection: direction };
      setValues(newValues);
      sessionStorage.setItem('requestsOrderDirection', direction);
      // Mescla: o estado local é uma cópia feita na montagem e não conhece os filtros
      // alterados fora do header (o período da coluna "Identificar Cliente", por exemplo).
      props.setValues((prevValues) => ({ ...prevValues, ...newValues }));
      props.handleChanged();
    }

    
    const handleChangePriority = (value) => {
      setValues((prevValues) => ({
        ...prevValues,
        'priority': value.target.value,
      }));
      sessionStorage.setItem('requestsPriority', (!values) ? 5 : value.target.value)
    }


    const handleSearch = () => {

      if(!values?.id){
        ShowMessage('error', 'Informe o atendente', 'Informe o usuário mesmo filtrando por setor')    
        return;
      }
      props.setValues((prevValues) => ({ ...prevValues, ...values }));
      props.handleChanged();

    }

  return (
        <Box sx={{display: 'flex', m: 2, fontSize: 13}}>
          <Grid container spacing={1} columns={ 12 } sx={{float: "center", justifyContent: 'space-between', }} >
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={{display: 'flex'}}>
              <FormControl variant="outlined" sx={{  minWidth: 120, mr: 1 }} size="small">
                <Select
                  labelId="type"
                  id="demo-simple-select-standard"
                  value={values?.type}
                  onChange={handleChangeType}
                >
                  <CustomMenuItem value={'user'}>Usuário</CustomMenuItem>
                  <CustomMenuItem value={'groups'}>Setor</CustomMenuItem>
                </Select>
              </FormControl>
              {values?.type === 'user'
                ?
                <Autocomplete
                  disablePortal
                  fullWidth
                  options={listUsers}
                  freeSolo={true}
                  getOptionLabel={ (option) => option['name'] || option }    
                  value={values?.name}
                  onChange={(event, values) => handleChangeUser(values)}
                  renderInput={(params) => 
                  <TextField
                   {...params} 
                    name="user"
                    label="Atendente" 
                    size="small"
                  />}
                />
                :
                <Autocomplete
                  disablePortal
                  fullWidth
                  options={listGroups}
                  getOptionLabel={ (option) => option['description'] || option }    
                  value={values?.nameGroup}
                  onChange={(event, values) => handleChangeGroup(values)}
                  renderInput={(params) => 
                  <TextField
                    name="group"
                    {...params} 
                    label="Setor" 
                    size="small"
                  />}
                />
              }

            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{display: 'flex', alignItems: 'center', gap: 1}}>
              <FormControl sx={{width: 160}} variant="outlined" size="small">
                <InputLabel htmlFor="filter">Filtro</InputLabel>
                <OutlinedInput
                  id="filter"
                  placeholder="Filtrar Atendimentos"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton type="button" sx={{ p: '10px' }} title='Opções' onClick={handleOpenFilter}>
                        <FilterListIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Filtro"
                  value={values.filter}
                  onChange={handleSetFilter}
                  onKeyDown={(e) => {if(e.key === "Enter")handleSearch()}}
                />
              </FormControl>
              <Button
                variant='contained'
                onClick={handleSearch}
              >
                <SearchIcon/>
              </Button>
              <FormControlLabel
                control={
                  <Checkbox
                    name={'order_direction'}
                    checked={values.orderDirection === 'DESC'}
                    onChange={handleChangeOrderDirection}
                    inputProps={{ 'aria-label': 'controlled' }}
                    size="small"
                  />
                }
                label="Listar mais recentes primeiro"
                sx={{ m: 0, whiteSpace: 'nowrap', '& .MuiFormControlLabel-label': { fontSize: 12 } }}
              />

              
            </Grid>
          </Grid>
          <Dialog open={openFilter} onClose={handleCloseFilter} sx={{ fontSize: 13}}> 
            <DialogTitle>Filtrar Atendimentos</DialogTitle>
            <DialogContent>
            <Grid container spacing={1} columns={ 12 } sx={{float: "center", m: 1, width: 300}} >
              <Grid item xs={12} md={12}  sx={{mb: 1}} >
                  <FormControl fullWidth size="small">
                  <InputLabel id="order-label">Ordem</InputLabel>
                  <Select
                    labelId="order-label"
                    label="Ordem"
                    fullWidth
                    name="order"
                    value={values.order}
                    onChange={handleChangeOrder}
                  >
                    <CustomMenuItem value={'s.created_at'}><em>Data de Abertura</em></CustomMenuItem>
                    <CustomMenuItem value={'s.start_date'}><em>Previsão para Atendimento</em></CustomMenuItem>
                  </Select>
                </FormControl>                                 
              </Grid>
              <Grid item xs={12} md={12}  sx={{mb: 1}} >
                  <FormControl fullWidth size="small">
                  <InputLabel id="priority-label">Prioridade</InputLabel>
                  <Select
                    labelId="priority-label"
                    label="Prioridade"
                    fullWidth
                    name="priority"
                    value={values.priority}
                    onChange={handleChangePriority}
                  >
                    <CustomMenuItem value={1}><em>Lista Padrão</em></CustomMenuItem>
                    <CustomMenuItem value={2}><em>Lista Vip</em></CustomMenuItem>     
                    <CustomMenuItem value={5}><em>Todos</em></CustomMenuItem>
                  </Select>
                </FormControl>                                 
              </Grid>   
              <FormControlLabel
                        control={
                          <Checkbox 
                            name={'show_hidden_requests'}
                            checked={values.ShowHiddenRequests === 'Y'} 
                            onChange={handleChangeChecks}
                            inputProps={{ 'aria-label': 'controlled' }} 
                            
                          />
                        }
                        label='Listar Atendimentos Ocultos'
              />            
            </Grid>
            </DialogContent>
          </Dialog>
        </Box>
  );
    
}